<template>
  <div id="dashboard-analytics">
    <h3 class="mb-5">Relatório Produtividade</h3>

    <vs-tabs v-model="currentTab">
      <vs-tab v-for="( nameTab ) in types" :key="nameTab" :label="nameTab">
        <vs-card id="vs-card" class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base">
          <div class="w-full flex justify-left items-center">
            <span style="margin: 2%; font-size: 120%"><b>Filtrar dados por periodo:</b></span>
            <flat-pickr
              ref="initial"
              v-model="initial_date"
              :config="initialConfigdateTimePicker"
              class="ml-8"
              placeholder="Intervalo inicial"
            />
            <flat-pickr
              ref="final"
              v-model="finish_date"
              :config="finalConfigdateTimePicker"
              class="ml-8"
              placeholder="Intervalo final"
            />

            <div class="ml-8 flex flex-col">
              <vs-checkbox v-model="showTenantInput"> <small>Nome da Plataforma</small> </vs-checkbox>
              <vs-checkbox v-model="onlyActivesTenants"> <small>Ocultar Tenants desligados (Apenas ativos)</small> </vs-checkbox>
            </div>

            <div class="ml-8">
              <vs-button :disabled="buttonDisabled || !canFilter" class="w-75" @click="filterDateAnalytics()">
                Filtrar
              </vs-button>
            </div>
          </div>
        </vs-card>
      </vs-tab>
    </vs-tabs>

    <div class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base" >
      <vx-card class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base">
        <div class="grid grid-cols-1 gap-4 md:gap-6 md:grid-cols-2" :class="'xl:grid-cols-1'">
          <div v-if="showTenantInput" class="p-3 rounded-lg shadow">
            <div class="flex items-start w-full">
              <div class="ml-4 flex-1 w-full">
                <h3 class="text-lg font-semibold mb-2">
                  🔍 Busca por Nome da Plataforma
                </h3>
                <div class="text-sm space-y-2">
                  <p class="leading-relaxed">
                    Digite o início do nome da Plataforma (ex: <code class="px-1 rounded text-xs">"drogaria"</code>) para buscar todos que começam com esse termo.
                  </p>
                  <div class="bg-white p-3 rounded-md border">
                    <p class="font-medium mb-1">💡 Como funciona:</p>
                    <p class="text-xs leading-relaxed">
                      É uma busca inteligente que encontrará as plataformas que "começam com". <br>
                      Exemplo: digitando "drogaria" busca <code class="px-1 rounded text-xs">drogaria</code>,
                      incluirá as plataformas como <code class="px-1 rounded text-xs">drogaria-do-bairro</code>,
                      <code class="px-1 rounded text-xs">drogaria-centro</code>, etc.
                    </p>
                  </div>
                </div>
                <div class="mt-4">
                  <label for="tenantInput" class="block text-sm font-medium mb-2">
                    Nome da Plataforma:
                  </label>

                  <vs-input
                    id="tenantInput"
                    v-model="tenantInput"
                    placeholder="Ex: drogaria, farmacia, clinica..."
                    class="w-full rounded-lg"
                    size="small"
                  />
                  <p v-if="tenantInput && !isTenantInputValid" class="text-xs mt-1 text-danger">
                    Nome inválido. Deve ter pelo menos 5 caracteres e corresponder a uma plataforma existente.
                  </p>
                  <p class="text-xs mt-1 italic">
                    Digite apenas o início do nome (sem espaços ou caracteres especiais)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="p-3 rounded-lg shadow">
            <tenants-slim-list checkbox :selecteds="hostnames" :only-actives="onlyActivesTenants" @selectedTenant="hostnamesChanged" />
          </div>
        </div>
      </vx-card>
    </div>

    <iframe
      :src="iframeUrl"
      allowtransparency
      class="iframe1"
      scrolling="no"
    ></iframe>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import VxTimeline from "@/components/timeline/VxTimeline.vue"
import TenantsSlimList from "@/views/Tenants/TenantsSlimList.vue";
import {mapGetters} from "vuex";
import { canSeeSensitiveReportDataBackOffice } from "@/utils";

export default {
  components: {TenantsSlimList, VxTimeline, flatPickr, vSelect},
  data() {
    return {
      currentTab: 0,
      hostnames: [],
      iframeUrl: null,
      finish_date: null,
      tenantInput: null,
      initial_date: null,
      buttonDisabled: false,
      showTenantInput: false,
      types: ['Atendimento', 'Campanha WhatsApp', 'Campanha Sms', 'Campanha Email', 'Operador'],
      dashboards: {
        attendance:       { dashboard: 4 },
        campaignWhatsapp: { dashboard: 5 },
        campaignSms:      { dashboard: 15},
        campaignEmail:    { dashboard: 14},
        operator:         { dashboard: 6 },
      },
      initialConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        dateFormat: 'd/m/Y',
        maxDate: new Date(),
        onChange: this.calendarChange
      },
      finalConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        minDate: null,
        maxDate: new Date(),
        dateFormat: 'd/m/Y',
      },
      onlyActivesTenants: true,
      payload: {
        resource: {},
        params: {},
        exp: Date.now() + (1000 * 60 * 60 * 24)
      }
    }
  },
  watch: {
    currentTab() {
      this.filterDateAnalytics()
    },
    hostnames(value){
      this.buttonDisabled = !value.length
    },
    showTenantInput(value){
      if (!value){ this.tenantInput = null; }
      else { this.hostnames = []; }
    },
    buttonDisabled(value) {
      if (value === true) {
        setTimeout(() => { this.buttonDisabled = false }, 1000)
      }
    },
    tenantInput(value) {
      const formatted = value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, '-').replace(/-+/g, '-');

      if (value && value !== formatted) {
        this.tenantInput = formatted;
      }
      if (this.showTenantInput) {
        if (value) {
          const filtered = this.tenants.filter(tenant => { return (tenant && tenant.fqdn ? tenant.fqdn.split(".")[0] : '').toLowerCase().startsWith(value) });
          this.hostnames = filtered.map(t => t.id);
        } else {
          this.hostnames = [];
        }
      }
    }
  },
  computed: {
    ...mapGetters(['token', 'tenants']),
    canSeeSensitiveReportData() {
      return canSeeSensitiveReportDataBackOffice()
    },
    isTenantInputValid() {
      if (!this.tenantInput || this.tenantInput.length < 5) return false;
      return this.tenants.some(tenant => {
        const prefix = (tenant && tenant.fqdn ? tenant.fqdn.split(".")[0] : '').toLowerCase();
        return prefix.startsWith(this.tenantInput.toLowerCase());
      });
    },
    canFilter() {
      if (this.showTenantInput) { return this.isTenantInputValid; }
      return this.hostnames.length > 0;
    },
    initialDate() {
      return this.stringToDate(this.initial_date, "dd/MM/yyyy", "/");
    },
    finishDate() {
      let finishedDate = this.stringToDate(this.finish_date, "dd/MM/yyyy", "/")
      finishedDate.setHours(23, 59, 59, 9998)
      return finishedDate;
    }
  },
  mounted(){
    this.verify()
  },
  methods: {
    stringToDate(_date, _format, _delimiter) {
      let formatLowerCase = _format.toLowerCase();
      let formatItems = formatLowerCase.split(_delimiter);
      let dateItems = _date.split(_delimiter);
      let dayIndex = formatItems.indexOf("dd");
      let monthIndex = formatItems.indexOf("mm");
      let yearIndex = formatItems.indexOf("yyyy");
      let month = parseInt(dateItems[monthIndex]);
      month -= 1;

      return new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    },
    verify(){
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor')
      if(!permissions && !twoFactor){
          this.$router.push('/user-settings')
      }else if(!permissions && twoFactor){
          this.$router.push('/two-factor')
      }
    },
    hostnamesChanged(selecteds){
      this.hostnames = selecteds
    },
    calendarChange(selectedDates) {
      this.finalConfigdateTimePicker.minDate = selectedDates[0]
    },
    filterDateAnalytics() {
      this.buttonDisabled = true;
      this.loadMetabase()
    },
    loadMetabase() {
      this.updatePayload()
      let token = jwt.sign(this.payload,  process.env.VUE_APP_METABASE_SECRET_KEY, '', '');
      this.iframeUrl = process.env.VUE_APP_METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=false&titled=false";
    },
    updatePayload() {
      switch (this.currentTab) {
        case 0:
          this.payload.resource = this.dashboards.attendance; break;
        case 1:
          this.payload.resource = this.dashboards.campaignWhatsapp; break;
        case 2:
          this.payload.resource = this.dashboards.campaignSms; break;
        case 3:
          this.payload.resource = this.dashboards.campaignEmail; break;
        case 4:
          this.payload.resource = this.dashboards.operator; break;
      }

      this.payload.params = {
        'user_id': '0',
        'data_final': this.finishDate,
        'data_inicial': this.initialDate,
        'tenant_ids': !this.showTenantInput ? this.hostnames.toString() : '0',
        'tenant': this.showTenantInput ? this.tenantInput : null
      }

      if (this.currentTab === 0){
        this.payload.params = Object.assign(this.payload.params, {
          'sensitive_data': this.canSeeSensitiveReportData.toString()
        });
      }
    }
  },
  async beforeMount() {
    const today = new Date()
    const yyyy = today.getFullYear()
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const todayDay = String(today.getDate()).padStart(2, '0')

    if ( !this.tenants.length ){
      await this.$store.dispatch('getAllTenants', { token: this.token })
    }

    this.initial_date = `${todayDay}/${mm}/${yyyy}`
    this.finish_date = `${todayDay}/${mm}/${yyyy}`
    this.hostnames = this.tenants.length > 0 ? [this.tenants[0].id] : []

    this.loadMetabase();
  }
}
</script>

<style lang="scss">

#dashboard-analytics {
  .loading-dashboard-graphs {
    height: 11rem;
    width: 100%;
  }

  #vs-card {
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .05) !important;
  }

  .iframe1 {
    width: 100%;
    border: none;
    height: 60vw;
    display: block;
    overflow-y: auto;
    border-radius: 20px;
    overflow-x: hidden;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);
  }

  @media(max-width: 1230px) {
    .iframe1 {
      height: 70vw !important;
    }
  }

  @media(max-width: 920px) {
    .iframe1 {
      height: 90vw !important;
    }
  }

  @media(max-width: 750px) {
    .iframe1 {
      height: 115vw !important;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right {
      width: 140px;
    }
    .iframe1 {
      height: 130vw !important;
    }
  }
}

</style>
